export const GLOBAL_MANAGE_ALL_USERS = "ManageAllUsers";
export const GLOBAL_MANAGE_ALL_PROJECTS = "ManageProjects";
export const GLOBAL_MANAGE_SPECIFIC_PROJECT = "ManageSpecificProject";
export const GLOBAL_MANAGE_ALL_MARKETS = "ManageMarkets";
export const GLOBAL_MANAGE_ORGANIZATIONS = "ManageOrganizations";
export const GLOBAL_MANAGE_SPECIFIC_ORGANIZATION = "ManageSpecificOrganization";
export const GLOBAL_MANAGE_BENEFICIARIES = "ManageBeneficiaries";
export const GLOBAL_MANAGE_PROJECT_MANAGERS = "ManageProjectManagers";
export const GLOBAL_MANAGE_SUBSCRIPTIONS = "ManageSubscriptions";
export const GLOBAL_MANAGE_CATEGORIES = "ManageCategories";
export const GLOBAL_MANAGE_CARDS = "ManageCards";
export const GLOBAL_MANAGE_TRANSACTIONS = "ManageTransactions";
export const GLOBAL_CREATE_TRANSACTION = "CreateTransaction";
export const GLOBAL_MANAGE_ORGANIZATION_MANAGERS = "ManageOrganizationManagers";
export const GLOBAL_MANAGE_PRODUCT_GROUP = "ManageProductGroup";
export const GLOBAL_REFUND_TRANSACTION = "RefundTransaction";
export const GLOBAL_MANAGE_MARKET_GROUPS = "ManageMarketGroups";
export const GLOBAL_MANAGE_SPECIFIC_MARKET_GROUP = "ManageSpecificMarketGroup";
export const GLOBAL_MANAGE_SPECIFIC_MARKET = "ManageSpecificMarket";
export const GLOBAL_MANAGE_MARKETGROUP_MANAGERS = "ManageMarketGroupManagers";

export const PROJECT_CREATE_PROJECT = "CreateProject";
export const PROJECT_MANAGE_PROJECT = "ManageProject";
export const PROJECT_DELETE_PROJECT = "DeleteProject";
export const PROJECT_MANAGE_ALL_PROJECTS = "ManageAllProjects";
export const PROJECT_CREATE_ORGANIZATION = "CreateOrganization";
export const PROJECT_CREATE_CARD = "CreateCard";

export const MARKET_CREATE_MARKET = "CreateMarket";
export const MARKET_MANAGE_MARKET = "ManageMarket";
export const MARKET_DELETE_MARKET = "DeleteMarket";
export const MARKET_MANAGE_ALL_MARKETS = "ManageAllMarkets";

export const ORGANIZATION_MANAGE_ORGANIZATION = "ManageOrganization";
export const ORGANIZATION_DELETE_ORGANIZATION = "DeleteOrganization";
